import AutogestionLogUpdate from './AutogestionLogUpdate'
export {AutogestionLogUpdate}
export default AutogestionLogUpdate
